import { Box, Typography } from '@mui/material';

export const Blank = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 30,
      }}
    >
      <Typography variant="h2" component="h2">
        Coming soon
      </Typography>
    </Box>
  );
};
